import {useEffect, useState} from "react";

export const useVerWidth = () => {
    const [ancho, setAncho] = useState(0)




    useEffect(() => {

        if (ancho !== window.innerWidth){
            setAncho(window.innerWidth)
        }
        const handleResize = () => {
            setAncho(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return {
        ancho
    }
}